// TODO rename to widgetFind and group together with other widgets (contextMenu, hover, tooltip)
export const Ajax = 1
export const Audio = 2
export const Base64 = 3
export const Blob = 4
export const CacheStorage = 5
export const Callback = 6
export const ClipBoard = 7
export const ColorPicker = 8
export const ColorTheme = 9
export const ColorThemeFromJson = 10
export const ContextMenu = 11
export const Developer = 12
export const Dialog = 13
export const Download = 14
export const EditorDiagnostics = 15
export const EditorError = 16
export const EditorRename = 17
export const ErrorHandling = 18
export const ExtensionHostCode = 19
export const ExtensionMeta = 20
export const Extensions = 21
export const FileSystem = 22
export const Format = 23
export const IconTheme = 24
export const ImagePreview = 25
export const KeyBindings = 26
export const KeyBindingsInitial = 27
export const Layout = 28
export const Listener = 29
export const LocalStorage = 30
export const Menu = 31
export const Navigatiom = 32
export const Notification = 33
export const Open = 34
export const Preferences = 35
export const QuickPick = 36
export const RecentlyOpened = 37
export const SaveState = 38
export const ServiceWorker = 39
export const SessionReplay = 40
export const SessionStorage = 41
export const Test = 42
export const TestFramework = 43
export const TestFrameworkComponent = 44
export const Viewlet = 45
export const Window = 46
export const Workbench = 47
export const Workspace = 48
export const ContentTracing = 49
export const OpenNativeFolder = 50
export const ElectronWindow = 51
export const Url = 52
export const Mime = 53
export const Eval = 54
export const FilePicker = 55
export const PersistentFileHandle = 56
export const IndexedDb = 57
export const Chrome = 58
export const ElectronBrowserView = 59
export const ChromeExtension = 60
export const ElectronApp = 61
export const ElectronContextMenu = 62
export const ElectronClipBoard = 63
export const SaveFileAs = 64
export const ElectronApplicationMenu = 65
export const About = 66
